import { render, staticRenderFns } from "./PendingRequest.vue?vue&type=template&id=53714bef"
import script from "./PendingRequest.vue?vue&type=script&lang=js"
export * from "./PendingRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports